// @flow
import styled from 'styled-components';
import { media } from '~/core/utils/style';

export const DeviceInfoPanelList = styled.ul`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: auto;
    margin-bottom: 30px;

    ${media.tablet`
		flex-wrap: nowrap;
	`};
`;

export const DeviceInfoPanelListItem = styled.li`
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    padding-right: 2em;
    margin-bottom: 15px;
    width: 50%;

    &:last-child {
        padding-right: 0;
    }

    ${media.tablet`
		margin-bottom: 0;
		width: auto;
	`};
`;

export const DeviceInfoPanelHeading = styled.h4`
    margin: 0 0 5px 0;
    height: 50%;
    font-weight: normal;
`;

export const DeviceInfoPanelValue = styled.div`
    height: 50%;
    font-weight: bold;
`;

export const DeviceInfoPanelValueInput = styled.input`
    padding: 3px;
    border: 1px solid ${props => props.theme.mediumGrey};

    &:focus {
        border-color: ${props => props.theme.grey};
        outline: none;
    }
`;



// WEBPACK FOOTER //
// ./src/components/widgets/device-info-panel/panel-list/styles.js